import { useState, useEffect } from "react";
import { accessAPI } from "../../shared";

/**
 * Si el organismo factura con Biller.
 *
 * De esto depende toda la pantalla de facturación. Con Biller, Morfeo emite el
 * comprobante y lo trae cuando se pide descargarlo. Sin Biller, el organismo lo
 * emite por fuera: el admin escribe el número al emitir y sube los archivos —la
 * factura, el comprobante de pago y la nota de crédito— cuando los tiene.
 *
 * Devuelve null mientras no se sabe, para poder no mostrar nada en vez de
 * mostrar la variante equivocada por un instante.
 */
export default function useConBiller() {
  const [conBiller, setConBiller] = useState(null);

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/facturacion/integracion",
      null,
      (respuesta) => setConBiller(Boolean(respuesta.conBiller)),
      // Si falla, se asume que no hay integración: es la variante que le
      // permite al admin cargar todo a mano y no lo deja sin salida.
      () => setConBiller(false)
    );
  }, []);

  return conBiller;
}
